module.exports = __webpack_public_path__ + "img/new-user.8cbcde9c.svg";